import { AttachmentFileList, AttachmentFileType, CloudFile } from 'owa-attachment-file-types';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import { trace } from 'owa-trace';
import { insertLinksIntoComposeEditor } from '../insertLinksFromFilePicker/insertLinksIntoComposeEditor';
import { InsertLinksHost } from 'owa-attachment-link-common';

export async function insertLinks(
    files: AttachmentFileList,
    insertLinksHost: InsertLinksHost,
    editorViewState: EditorViewState,
    fromAddress: string,
    targetWindow: Window
) {
    // We only support insert from cloudy providers for now
    const filteredFiles: CloudFile[] = [];
    for (let i = 0; i < files.length; i++) {
        if (files[i].fileType === AttachmentFileType.Cloud) {
            const cloudFile: CloudFile = files[i] as CloudFile;
            filteredFiles.push(cloudFile);
        } else {
            trace.error(`insert link handler recieved invalid file type ${files[i].fileType}`);
        }
    }

    if (!filteredFiles || filteredFiles.length === 0) {
        trace.error('No files for inserting link from filepicker');
        return;
    }

    const getRecipientWells = (): RecipientWellWithFindControlViewState[] => [
        insertLinksHost.toRecipientWell,
        insertLinksHost.ccRecipientWell,
        insertLinksHost.bccRecipientWell,
    ];

    insertLinksIntoComposeEditor(
        editorViewState,
        filteredFiles,
        insertLinksHost.attachmentWell,
        getRecipientWells,
        fromAddress,
        targetWindow
    );
}
